import * as Vest from 'vest';

export const FormSuite = Vest.create((data = {}) => {
  
    
    Vest.test('MonthlyAmount', 'ERROR_AMOUNT_NET', () => {
        if(data?.NetToBrutCheck == true)
        {
            Vest.enforce(data.MonthlyAmount).allOf(Vest.enforce.greaterThan(0), Vest.enforce.lessThanOrEquals(3000000));
        }
        else
        {
            return true;
        }
    });

    Vest.test('MonthlyAmount', 'ERROR_AMOUNT_BRUT', () => {
        if(data?.NetToBrutCheck == false)
        {
            Vest.enforce(data.MonthlyAmount).allOf(Vest.enforce.greaterThan(0), Vest.enforce.lessThanOrEquals(7000000));
        }
        else
        {
            return true;
        }
    });



    Vest.test('ProfDeductionAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.ProfDeductionAmount).greaterThanOrEquals(0);
    });

    Vest.test('GrossSubmittedAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.GrossSubmittedAmount).greaterThanOrEquals(0);
    });
 
    Vest.test('NetBenefitAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.NetBenefitAmount).greaterThanOrEquals(0);
    });

    Vest.test('NetCarBenefitAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.NetCarBenefitAmount).greaterThanOrEquals(0);
    });
    
    Vest.test('CollectiveInsuranceAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.CollectiveInsuranceAmount).greaterThanOrEquals(0);
    });

    Vest.test('OtherNegativeAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.OtherNegativeAmount).greaterThanOrEquals(0);
    });

    Vest.test('OtherPositiveAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.OtherPositiveAmount).greaterThanOrEquals(0);
    });

    Vest.test('CollectiveInsuranceEmployeurIntervAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.CollectiveInsuranceEmployeurIntervAmount).greaterThanOrEquals(0);
    });

    Vest.test('EndYearBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.EndYearBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('EndYearBonusAmountForemSubmitted', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.EndYearBonusAmountForemSubmitted).greaterThanOrEquals(0);
    });

    Vest.test('EndYearBonusAmountForemNotSubmitted', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.EndYearBonusAmountForemNotSubmitted).greaterThanOrEquals(0);
    });

    Vest.test('Commissions', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.Commissions).greaterThanOrEquals(0);
    });

    Vest.test('NonReccurentDirectorAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.NonReccurentDirectorAmount).greaterThanOrEquals(0);
    });

    Vest.test('MonthlyCopyrightAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.MonthlyCopyrightAmount).greaterThanOrEquals(0);
    });

    Vest.test('CurrentDoubleBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.CurrentDoubleBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('CurrentAdditionalBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.CurrentAdditionalBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('PreviousBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.PreviousBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('PreviousDoubleBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.PreviousDoubleBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('PreviousAdditionalBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.PreviousAdditionalBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('AdvanceBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.AdvanceBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('AdvanceDoubleBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.AdvanceDoubleBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('AdvanceAdditionalBonusAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.AdvanceAdditionalBonusAmount).greaterThanOrEquals(0);
    });

    Vest.test('PublicTransportationAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.PublicTransportationAmount).greaterThanOrEquals(0);
    });

    Vest.test('PrivateTransportationAmount', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.PrivateTransportationAmount).greaterThanOrEquals(0);
    });


    // max value

    
    Vest.test('ProfDeductionAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.ProfDeductionAmount).lessThanOrEquals(1000000);
    });

    Vest.test('GrossSubmittedAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.GrossSubmittedAmount).lessThanOrEquals(1000000);
    });
 
    Vest.test('NetBenefitAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.NetBenefitAmount).lessThanOrEquals(1000000);
    });

    Vest.test('NetCarBenefitAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.NetCarBenefitAmount).lessThanOrEquals(1000000);
    });
    
    Vest.test('CollectiveInsuranceAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.CollectiveInsuranceAmount).lessThanOrEquals(1000000);
    });

    Vest.test('OtherNegativeAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.OtherNegativeAmount).lessThanOrEquals(1000000);
    });

    Vest.test('OtherPositiveAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.OtherPositiveAmount).lessThanOrEquals(1000000);
    });

    Vest.test('CollectiveInsuranceEmployeurIntervAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.CollectiveInsuranceEmployeurIntervAmount).lessThanOrEquals(1000000);
    });

    Vest.test('EndYearBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.EndYearBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('EndYearBonusAmountForemSubmitted', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.EndYearBonusAmountForemSubmitted).lessThanOrEquals(1000000);
    });

    Vest.test('EndYearBonusAmountForemNotSubmitted', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.EndYearBonusAmountForemNotSubmitted).lessThanOrEquals(1000000);
    });

    Vest.test('Commissions', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.Commissions).lessThanOrEquals(1000000);
    });

    Vest.test('NonReccurentDirectorAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.NonReccurentDirectorAmount).lessThanOrEquals(1000000);
    });

    Vest.test('MonthlyCopyrightAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.MonthlyCopyrightAmount).lessThanOrEquals(1000000);
    });

    Vest.test('CurrentDoubleBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.CurrentDoubleBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('CurrentAdditionalBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.CurrentAdditionalBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('PreviousBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.PreviousBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('PreviousDoubleBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.PreviousDoubleBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('PreviousAdditionalBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.PreviousAdditionalBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('AdvanceBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.AdvanceBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('AdvanceDoubleBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.AdvanceDoubleBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('AdvanceAdditionalBonusAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.AdvanceAdditionalBonusAmount).lessThanOrEquals(1000000);
    });

    Vest.test('PublicTransportationAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.PublicTransportationAmount).lessThanOrEquals(1000000);
    });

    Vest.test('PrivateTransportationAmount', 'ERROR_AMOUNT_MAX', () => {
        Vest.enforce(data.PrivateTransportationAmount).lessThanOrEquals(1000000);
    });
});